import { useMutation } from '@connectrpc/connect-query'
import { transitionBiddingSpotDrafts } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'
import { useQueryClient } from '@tanstack/react-query'

import { invalidateSpotApprovalRequestQueries } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * スポット入札 (通常入札) の下書きから、 指定した札だけを承認申請または提出する mutation hook
 * (AC-BSP-007 / #7758)。 targets は申請セットごとで、 承認申請か提出かは backend が各申請セットの
 * 承認モードから導く。
 *
 * 他の遷移 hook (`useInvalidatingMutation`) と違い、 失敗でも一覧と明細を読み直す。 拒否の多くは
 * 他のユーザーが先に更新したことによるもので、 画面が古いままだとやり直しても同じ拒否になる。
 */
export function useTransitionBiddingSpotDrafts(): InvalidatingMutationResultFor<
  typeof transitionBiddingSpotDrafts
> {
  const queryClient = useQueryClient()
  return useWorkflowCaseScopedMutation(
    useMutation(transitionBiddingSpotDrafts, {
      onSettled: () => invalidateSpotApprovalRequestQueries(queryClient),
    }),
  )
}
